import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import style from './radio-box.scss';

@CSSModules(style)
export default class RadioBox extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    formFieldName: PropTypes.string,
    formFieldLabel: PropTypes.string,
    setType: PropTypes.func,
    getFormValue: PropTypes.func
  }

  handleChange(e) {
    this.handleElementChange(e.target);
  }

  handleElementChange(el) {
    if (this.context.onChange) {
      this.context.onChange(this.context.formFieldName, el.checked);
    }

    if (this.props.onChange) {
      this.props.onChange(el.checked);
    }
  }

  componentDidMount() {
    this.handleElementChange(this.refs.element);
  }

  componentWillMount() {
    if (this.context.setType) this.context.setType('RadioBox');
  }

  get value() {
    if (this.context.getFormValue) {
      return this.context.getFormValue(this.name);
    } else {
      return this.props.value;
    }
  }

  get name() {
    return this.context.formFieldName || this.props.name;
  }

  get label() {
    return this.context.formFieldLabel || this.props.label;
  }

  render() {
    return (
      <label styleName="root">
        <input
          name={'radio-' + Math.random()}
          ref="element"
          type="radio"
          onChange={::this.handleChange}
          checked={!!this.value}
        />
        <span styleName="checkbox" />
        <span styleName="label">
          {this.label}
        </span>
      </label>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/radio-box.js